import React from "react";

export default ({ label }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="32"
    width="32"
    viewBox="0 0 31.999999 31.999996"
    alt={label}
  >
    <path
      style={{
        textDecorationColor: "#000",
        isolation: "auto",
        mixBlendMode: "normal",
        blockProgression: "tb",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textIndent: 0,
        textTransform: "none",
      }}
      d="m21.994 1030.4c-0.50687 0-1.0138 0.3408-1 1.0211v1.6641c-1.017-1.5276-2.7039-2.5454-4.6035-2.6699-2.5612-0.1679-4.9533 1.3181-5.9355 3.6894-0.98223 2.3713-0.34185 5.1163 1.5879 6.8086 1.9297 1.6924 4.7342 1.967 6.957 0.6836 1.2272-0.6462 0.17265-2.471-1-1.7305-1.4873 0.8587-3.3475 0.6754-4.6387-0.457-1.2912-1.1323-1.7158-2.9524-1.0586-4.5391 0.65722-1.5866 2.2433-2.5732 3.957-2.4609 1.3527 0.089 2.5294 0.8514 3.1875 1.9824h-1.4238c-1.3607-0.031-1.3662 2.0236-0.006 2l3.9826 0.01c0.26076 0.0008 0.50226-0.1075 0.68945-0.2891 0.19427-0.1884 0.31061-0.4403 0.31055-0.7109l-0.006-3.9805c0.0139-0.6803-0.49313-1.0211-1-1.0211z"
      color="#000"
      solid-color="#000000"
      white-space="normal"
      transform="translate(0 -1020.4)"
    />
  </svg>
);
